import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, StarRating, Button, ModalWrapper, TextBox } from '../common';
import { makeServiceLabels, getBadgeServiceType } from '../../constants/serviceLabels';

export default function ReviewEditModal({ review, onClose, onSave, onDelete }) {
  const { t } = useTranslation();
  const serviceLabels = makeServiceLabels(t);
  const [rating, setRating] = useState(review.rating);
  const [text, setText] = useState(review.content || review.text || '');
  const serviceName = (review.service_type && serviceLabels[review.service_type]) || review.service || review.service_label || t('service.airport_transfer');

  const ratingOptions = [
    { value: 5, label: `5 ${t('common.point')}` },
    { value: 4, label: `4 ${t('common.point')}` },
    { value: 3, label: `3 ${t('common.point')}` },
    { value: 2, label: `2 ${t('common.point')}` },
    { value: 1, label: `1 ${t('common.point')}` },
  ];

  return (
    <ModalWrapper onClose={onClose} padding="p-5 sm:p-8" gap="gap-5">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-bold text-mono-900">{t('common.review_edit_title')}</h2>
        <Button level="level3" size="sm" onClick={() => onDelete(review.id)}>{t('common.review_delete')}</Button>
      </div>

      {/* Review info */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <Badge variant="service" serviceType={getBadgeServiceType(review.service_type)}>{serviceName}</Badge>
          <StarRating rating={rating} />
          <span className="text-2sm font-bold text-mono-900">{rating.toFixed(1)}</span>
        </div>

        <p className="text-md font-bold text-mono-900">{review.title}</p>

        <div className="flex flex-col gap-1">
          <p className="text-2sm text-mono-500">
            <span className="inline-block w-[72px]">{t('common.reservation_no_label')}</span>{review.reservationNo}
          </p>
          <p className="text-2sm text-mono-500">
            <span className="inline-block w-[72px]">{t('common.usage_datetime_label')}</span>{review.usageDate}
          </p>
          <p className="text-2sm text-mono-500">
            <span className="inline-block w-[72px]">{t('common.created_at_label')}</span>{review.created_at ? new Date(review.created_at).toLocaleString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).replace(/\. /g, '-').replace('.', '') : '-'}
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-mono-100" />

      {/* 후기 별점 */}
      <TextBox
        variant="select"
        label={t('common.review_rating')}
        value={rating}
        onChange={(e) => setRating(Number(e.target.value))}
        options={ratingOptions}
      />

      {/* 후기 글 */}
      <TextBox
        variant="textarea"
        label={t('common.review_text')}
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={5}
      />

      {/* Bottom buttons */}
      <div className="flex gap-3">
        <Button level="level3" fullWidth onClick={onClose}>{t('common.cancel')}</Button>
        <Button level="level1" fullWidth onClick={() => onSave(review.id, { rating, text })}>{t('common.edit')}</Button>
      </div>
    </ModalWrapper>
  );
}
